import { useEffect, useState } from "react"

export default function useContrast() {
  const [reduced, setReduced] = useState(process.browser && document.documentElement.classList.contains("prefers-contrast") || false)

  useEffect(() => {
    const html = document.documentElement
    const observer = new MutationObserver(([{ attributeName }]) => {
      if (attributeName === "class") {
        if (html.classList.contains("prefers-contrast"))
          setReduced(true)
        else
          setReduced(false)
      }
    })

    observer.observe(html, {
      subtree: false,
      attributes: true
    })

    return () => observer.disconnect()
  })

  return reduced
}